<template>
    <div
        class="lock-anim h-[160px] w-[160px]"
        aria-hidden="true"
        v-html="lockSvgRaw"
    />
</template>

<script setup lang="ts">
import lockSvgRaw from "@/assets/images/svg-lock.svg?raw";
</script>

<style scoped>
.lock-anim {
    overflow: hidden;
    line-height: 0;
    isolation: isolate;
}

.lock-anim :deep(svg) {
    width: 160px;
    height: 160px;
    display: block;
}

.lock-anim :deep(#backLock) {
    transform-box: fill-box;
    animation: floatBack 8.8s ease-in-out infinite;
    will-change: transform;
}

.lock-anim :deep(#frontLock) {
    transform-box: fill-box;
    animation: floatFront 3.8s ease-in-out infinite;
    will-change: transform;
}

.lock-anim :deep(#backLock),
.lock-anim :deep(#frontLock) {
    transform-origin: 50% 60%;
}

@keyframes floatFront {
    0%,
    100% {
        transform: translateY(0) rotate(0deg);
    }
    50% {
        transform: translateY(-7px) rotate(-1.4deg);
    }
}

@keyframes floatBack {
    0%,
    100% {
        transform: translateY(0) rotate(0deg);
    }
    50% {
        transform: translateY(-3px) rotate(-0.6deg);
    }
}

@media (prefers-reduced-motion: reduce) {
    .lock-anim :deep(#backLock),
    .lock-anim :deep(#frontLock) {
        animation: none !important;
    }
}
</style>
